export default __webpack_public_path__ + "static/media/mac-icon.7b4543ab.svg";